import type { CurrencyProduct } from '~/services/currency-catalogue'
import type { RemoteArtworkStatus } from '~/lib/remote-image'
import type { JSXElement } from 'solid-js'
import { RemoteArtwork } from './remote-artwork'

export type CurrencyArtworkStatus = RemoteArtworkStatus

// Currency product art (GLOSSARY.md "Currency product art"): the shared
// remote-artwork area keyed to a product, so the card, confirmation, and
// Reward reveal report load state for the same URL to one shared status.
export function CurrencyArtwork<Product extends CurrencyProduct>(props: {
  children?: JSXElement
  class: string
  onError: (product: Product) => void
  onLoad: (product: Product) => void
  product: Product
  status: CurrencyArtworkStatus
  testId: string
}) {
  return (
    <RemoteArtwork
      class={props.class}
      onError={() => props.onError(props.product)}
      onLoad={() => props.onLoad(props.product)}
      src={props.product.imageUrl}
      status={props.status}
      testId={props.testId}
    >
      {props.children}
    </RemoteArtwork>
  )
}
